/**
 * MUI sx style definitions for BottlerElmAccess component.
 */
export const bottlerElmAccessStyles = {
  applicationFilter: {
    width: 450,
    maxWidth: "100%",
    mx: "auto",
    mb: 3,
  },
  tabNavigation: {
    mb: 2,
    px: { xs: 0.5, sm: 1 },
    bgcolor: "#FFFFFF",
    border: "1px solid #E2E8F0",
    borderRadius: "10px",
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
  },
  tabs: {
    minHeight: 44,
    "& .MuiTabs-indicator": {
      height: 3,
      borderRadius: "3px 3px 0 0",
      bgcolor: "#C0253A",
    },
  },
  tab: {
    minHeight: 44,
    px: { xs: 1.5, sm: 2.5 },
    color: "#64748B",
    fontSize: "0.82rem",
    fontWeight: 700,
    textTransform: "none",
    "&.Mui-selected": {
      color: "#C0253A",
    },
    // Keep the disabled (no application selected) state greyed out even when selected.
    "&.Mui-disabled": {
      color: "#64748B",
    },
  },
  tabPanel: {
    minWidth: 0,
    outline: "none",
  },
  emptyState: {
    minHeight: 180,
    px: 2,
    py: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    bgcolor: "#FFFFFF",
    border: "1px dashed #CBD5E1",
    borderRadius: "12px",
  },
  emptyStateIcon: {
    mb: 1,
    color: "#C0253A",
    fontSize: 28,
  },
  emptyStateTitle: {
    color: "#1E2939",
    fontSize: "0.95rem",
    fontWeight: 700,
  },
  emptyStateMessage: {
    mt: 0.45,
    color: "#64748B",
    fontSize: "0.78rem",
  },
  topActionRow: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    mb: 1,
  },
  ribbon: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    backgroundColor: "#e8f4fd",
    border: "1px solid #b3d4f0",
    borderRadius: 1,
    px: 2,
    py: 1,
    mb: 2,
  },
  ribbonIcon: {
    color: "#1976d2",
    fontSize: 20,
    flexShrink: 0,
  },
  ribbonText: {
    fontSize: "0.8rem",
    color: "#1565c0",
  },
};
